export default "__VITE_ASSET__BYM3UaGE__"